/**
 * Hands the browser a CSV file to save. Shared by every admin export so the
 * Excel details live in one place.
 *
 * Content is expected `;`-separated with cells already escaped
 * (`csvFieldEscape.ts`), which is what German Excel opens without an import
 * dialog.
 */
export const downloadCsv = (fileName: string, csvContent: string): void => {
    // UTF-8 BOM for Excel compatibility — without it umlauts arrive garbled.
    const BOM = '﻿';
    const blob = new Blob([BOM + csvContent], {
        type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
};
